import React from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
  const toTop = () => {
    if (window.__lenis) window.__lenis.scrollTo(0);
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={toTop}
      aria-label="Torna in alto"
      data-testid="back-to-top"
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full border border-[#C5A059]/60 bg-[#0A0A0C]/85 text-[#C5A059] backdrop-blur-md transition-all duration-500 hover:bg-[#C5A059] hover:text-[#0A0A0C]"
    >
      <ArrowUp size={16} strokeWidth={1.5} />
    </button>
  );
}
